import { format } from 'date-fns';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { useUserDateFnsLocale, useUserDateFormat } from '@/i18n/hooks';

interface Props {
  fromDate: Date;
  toDate: Date;
}

export const DateIntervalText: FC<Props> = ({ fromDate, toDate }) => {
  const texts = useTexts();

  const dateFnsLocale = useUserDateFnsLocale();
  const dateFormat = useUserDateFormat('short');

  const fromDateFormatted = format(fromDate, dateFormat, {
    locale: dateFnsLocale,
  });
  const toDateFormatted = format(toDate, dateFormat, {
    locale: dateFnsLocale,
  });

  return (
    <span className="font-details">{`${texts.widgets.portfolio.summary.title} ${fromDateFormatted} - ${toDateFormatted}`}</span>
  );
};
